export enum CheckZipErrorType {
  OutsideRegion = "outsideregion",
  CannotResolve = "cannotresolve"
}
